export enum WalletTransactionEnums {
    USER_TO_COOK_PAYMENT = 'USER_TO_COOK_PAYMENT',
    ONE_MEAL_SERVICE = "ONE_MEAL_SERVICE",
    DISCOUNT_COUPON_ORDER = "DISCOUNT_COUPON_ORDER",
    CHEF_FOR_PARTY_ORDER = "CHEF_FOR_PARTY_ORDER",
    CHEF_FOR_PARTY = "CHEF_FOR_PARTY",
    WALLET_CASH_CREDIT = "WALLET_CASH_CREDIT",
    WAALLET_CASH_EXPIRED = "WAALLET_CASH_EXPIRED",
}